export default {
    accesos: [
        { route: 'dashboard', modulo: '' },

        { route: 'proveedores', modulo: '' },
        { route: 'proveedores/proveedores', modulo: '' },
        { route: 'proveedores/proveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id/ABM', modulo: '' },
        { route: 'proveedores/ordenesproveedores/orden-interna', modulo: '' },

        { route: 'rrhh', modulo: '' },
        { route: 'rrhh/personal', modulo: '' },
        { route: 'rrhh/personal/add', modulo: '' },
        { route: 'rrhh/personal/:id/edit', modulo: '' },
        { route: 'rrhh/personal/:id', modulo: '' },
        { route: 'rrhh/encuestas', modulo: '' },
        { route: 'rrhh/encuestas/:id', modulo: '' },
        { route: 'rrhh/encuestas/:id/completar', modulo: '' },

        /* Temporal (licencia) */
        { route: 'seguridad', modulo: '' },
        { route: 'seguridad/usuarios', modulo: '' },
        { route: 'seguridad/usuarios/:id', modulo: '' },
        { route: 'seguridad/usuarios/:id/edit', modulo: '' }
    ]
}
